module.exports = __webpack_public_path__ + "static/media/CNX500.6c3e89b8.txt";